import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Eob = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="eob icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 6.82843C3 6.29799 3.21071 5.78929 3.58579 5.41421L8.41421 0.585787C8.78929 0.210714 9.29799 0 9.82843 0L19 0C20.1046 0 21 0.895431 21 2V22C21 23.1046 20.1046 24 19 24H5C3.89543 24 3 23.1046 3 22V6.82843ZM10 7V2.5L5.5 7H10ZM14.8536 11.2V16.1H16.5406C17.5416 16.1 18.1576 15.575 18.1576 14.623C18.1576 14 17.8846 13.615 17.4226 13.426C17.7306 13.265 17.9056 12.922 17.9056 12.523C17.9056 11.634 17.3386 11.2 16.5056 11.2H14.8536ZM16.4566 13.104H15.7636V12.04H16.4356C16.8206 12.04 17.0306 12.173 17.0306 12.572C17.0306 12.971 16.8206 13.104 16.4566 13.104ZM16.4566 15.26H15.7636V13.944H16.4566C17.0236 13.944 17.2476 14.182 17.2476 14.602C17.2476 15.022 17.0236 15.26 16.4566 15.26ZM12.0108 16.156C10.9468 16.156 10.1068 15.33 10.1068 13.65C10.1068 11.97 10.9468 11.144 12.0108 11.144C13.0748 11.144 13.9148 11.97 13.9148 13.65C13.9148 15.33 13.0748 16.156 12.0108 16.156ZM12.0108 15.316C12.5498 15.316 13.0048 14.882 13.0048 13.65C13.0048 12.418 12.5498 11.984 12.0108 11.984C11.4718 11.984 11.0168 12.418 11.0168 13.65C11.0168 14.882 11.4718 15.316 12.0108 15.316ZM6.13702 11.2V16.1H9.31502V15.26H7.04702V13.909H8.89502V13.069H7.04702V12.04H9.24502V11.2H6.13702Z"
    />
  </svg>
)
